import { AgentsCitationIcon, Icon, type IconProps } from '@grammarly/design-system'

type CitationFinderAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const CitationFinderAgentIcon = ({
  size,
  accessibilityLabel,
}: CitationFinderAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsCitationIcon}
      accessibilityLabel={accessibilityLabel ?? 'Citation Finder Agent'}
    />
  )
}
